<template>
  <div>
    <reporting-category-add
      :is-active="isModalActive"
      :customer-id="Number(this.$route.params.id)"
      :is-add="isAdd"
      :is-edit="isEdit"
      :action="action"
      :edit-object-name="editData"
      @confirm="editConfirm"
      @cancel="editCancel"
      :country="countries"
      :container="containers"
      :scheme="schemes"
    />
    <reporting-category-history-modal
      :is-active="isHistoryModalActive"
      :data="historyData"
      @cancel="isHistoryModalActive = false"
    />

    <div class="level no-margin">
      <div class="level-left">
        <div class="level-item">
          <div style="display: flex; flex-direction: column;">
            <div
              style="display: flex; flex-direction: row; align-items: center;"
            >
              <span class="button-padding-right" v-if="data.length > 0">
                Status:
                <a
                  href="#"
                  class="inactiveLink"
                  v-bind:class="getWorkFlowStatusClass"
                  >{{ workflowStatus }}</a
                >
              </span>
              <span
                class="button-padding-right"
                v-if="workflowStatus == 'Approved'"
              >
                Approved on:
                <a
                  href="#"
                  class="inactiveLink"
                  v-bind:class="getWorkFlowStatusClass"
                  >{{ updateDate }}</a
                >
              </span>
            </div>
            <div
              style="display: flex; flex-direction: row; align-items: center;"
            >
              <span
                class="button-padding-right"
                v-if="workflowStatus == 'Approved'"
              >
                Approved by:
                <a
                  href="#"
                  class="inactiveLink"
                  v-bind:class="getWorkFlowStatusClass"
                  >{{ approvedOrRejectedBy }}</a
                >
              </span>
            </div>
          </div>
          <span
            v-if="workflowStatus == 'Rejected' && isEnabled"
            class="additional-info"
          >
            <b-tooltip type="is-primary" :label="rejectionComment" multilined>
              <i class="mdi mdi-information"></i>
            </b-tooltip>
          </span>
          <div class="button-padding-right">
            <b-button
              v-if="isEnabled"
              slot="right"
              type="is-success"
              @click="changeWorkflowStatus('Approved')"
              outlined
            >
              Approve
            </b-button>
          </div>

          <div class="button-padding-right">
            <b-button
              v-if="isEnabled"
              slot="right"
              type="is-danger"
              @click="isCardModalActive = true"
              outlined
            >
              Reject
            </b-button>
          </div>
        </div>
      </div>
      <div :class="{ 'level-right': data.length > 0 && isEditAllowed() }">
        <div
          class="level-item-horizontal"
          :class="{
            'button-padding-right': data.length > 0 && isEditAllowed()
          }"
        >
          <ul class="context-options-right actions-desktop">
            <li v-if="data.length > 0">
              <a @click.prevent="exportReportingTemplate"
                >Download Reporting Template</a
              >
            </li>
            <li v-if="isEditAllowed()"><a @click.prevent="addModal">Add</a></li>
            <li v-if="data.length > 0">
              <a @click.prevent="exportReportingCategory">Export</a>
            </li>
            <li v-if="isEditAllowed()">
              <a @click.prevent="showHistoryModal" v-if="historyData.length > 0"
                >History</a
              >
            </li>
          </ul>
          <div class="actions-mobile">
            <b-dropdown position="is-bottom-left" aria-role="list">
              <span slot="trigger" class="action-dropdown">
                Actions
                <span class="icon is-small">
                  <i class="mdi mdi-menu-down"></i>
                </span>
              </span>
              <b-dropdown-item
                v-if="data.length > 0"
                @click.prevent="exportReportingTemplate"
              >
                Download Reporting Template
              </b-dropdown-item>
              <b-dropdown-item v-if="isEditAllowed()" @click.prevent="addModal">
                Add
              </b-dropdown-item>
              <b-dropdown-item
                v-if="data.length > 0"
                @click.prevent="exportReportingCategory"
              >
                Export
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div
          class="level-item-horizontal"
          :class="{
            'button-padding-right': workflowStatus != 'Send for Approval'
          }"
        >
          <b-button
            v-if="!disabled && data.length > 0 && workflowStatus != 'Draft'"
            @click="changeWorkflowStatus('Draft')"
            class="save-as-draft-button"
          >
            Save as Draft
          </b-button>
        </div>
        <div class="level-item-horizontal" v-if="data.length > 0">
          <b-button
            v-if="!disabled && workflowStatus != 'Send for Approval'"
            slot="right"
            type="is-primary"
            @click="changeWorkflowStatus('Sent for Approval')"
          >
            Send for Approval
          </b-button>
        </div>
      </div>
    </div>
    <div class="enable-select-text">
      <circul8-table
        ref="circul8Table"
        className="reporting-category-table"
        :records="data"
        :fields="columns"
        :routeNext="false"
        :usePropRecords="true"
        @clickcheck="checkCheckBox"
        @clickEdit="editModal"
        @clickView="viewModal"
        :infoPosition="0"
        @clickDelete="deleteModal"
        :showRemoveButton="showDelete"
        :showEditButton="showEdit"
        :isCheckable="true"
        :maxTextLength="'26'"
        :isLoading="isDataLoading"
        :noDataMsg="updateNoDataMsg"
        :backendSortingEnabled="true"
        @querySet="searchByFilter"
        @backendSort="sortData"
        :allCountries="countries"
      />
    </div>
    <b-modal v-model="isCardModalActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-reject">
            You are rejecting the changes
          </p>
        </header>
        <section class="modal-card-body">
          <b-field label="Please describe the reasons">
            <b-input
              maxlength="500"
              type="textarea"
              v-model="rejectComment"
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Close"
            class="reject-modal-close-button"
            @click="isCardModalActive = false"
          />
          <b-button
            label="Reject"
            type="is-danger"
            @click="changeWorkflowStatus('Rejected')"
          />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { forkJoin } from "rxjs";
import reportingCategoryAdd from "@/components/Customers/ReportingCategoryAdd.vue";
import reportingCategoryHistoryModal from "@/components/Customers/ReportingCategoryHistory.vue";
import ReportingCategoryService from "@/services/ReportingCategoryService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import Circul8Table from "../../components/Circul8Table.vue";
import utilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { Permission } from "../../services/Permissions";
import { UserGroup } from "../../services/UserGroups";
import { mapGetters } from "vuex";
import * as dayjs from "dayjs";

// @group Customers
export default {
  name: "ReportingCategory",
  mixins: [utilityMixin, ScopeMixin],
  components: {
    reportingCategoryAdd,
    Circul8Table,
    reportingCategoryHistoryModal
  },

  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    contactAction: {
      type: Boolean,
      default: false
    },
    customerAccountManager: {
      type: Number,
      default: 0
    },
    backupCustomerAccountManager: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isModalActive: false,
      uploadFees: false,
      isAdd: false,
      isEdit: false,
      action: null,
      editObject: this.getClearFormObject(),
      editData: {},
      tableHeight: "",
      users: [],
      checkedRow: [],
      data: [],
      customers: [],
      customerMap: {},
      reportingCategoryId: null,
      workflowStatus: null,
      updateDate: null,
      approvedOrRejectedBy: null,
      rejectionComment: null,
      isDataLoading: false,
      isCardModalActive: false,
      isHistoryModalActive: false,
      historyData: [],
      rejectComment: null,
      columns: [
        {
          field: "customer",
          label: "Customer",
          type: "input",
          searchable: true,
          visible: true,
          filterKey: { customer: "" },
          width: "200"
        },
        {
          field: "entity",
          label: "Entity",
          type: "input",
          searchable: true,
          visible: true,
          filterKey: { entity: "" },
          width: "200"
        },
        {
          field: "country",
          label: "Country",
          searchable: true,
          width: "200",
          visible: true,
          searchKey: "country",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: this.countries,
          filterKey: { country: [] }
        },
        {
          field: "stream",
          label: "Stream",
          type: "multiSelectFilter",
          width: "200",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.stream,
          filterKey: { stream: [] }
        },
        {
          field: "scheme",
          label: "Scheme",
          width: "200",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.containers,
          filterKey: { scheme: [] }
        },
        {
          field: "short_report_name",
          label: "Short Report Name",
          type: "input",
          searchable: true,
          visible: true,
          filterKey: { short_report_name: "" },
          width: "200"
        },
        {
          field: "main_category",
          label: "Main Category",
          type: "input",
          searchable: true,
          visible: true,
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "additional_delete_info",
          filterKey: { main_category: "" },
          width: "200"
        },
        {
          field: "sub_category",
          label: "Sub Category",
          type: "input",
          searchable: true,
          visible: true,
          filterKey: { sub_category: "" },
          width: "200"
        },
        {
          field: "valid_from",
          label: "Valid From",
          searchable: true,
          visible: true,
          dateField: true,
          type: "dateField",
          dateFilterKey: "valid_from_key",
          filterKey: { valid_from: [] }
        },
        {
          field: "valid_to",
          label: "Valid To",
          searchable: true,
          visible: true,
          dateField: true,
          type: "dateField",
          dateFilterKey: "valid_to_key",
          filterKey: { valid_to: [] }
        },
        {
          field: "example_product",
          label: "Example of Product",
          class: "enable-select-text",
          type: "input",
          searchable: true,
          visible: true,
          filterKey: { example_product: "" },
          width: "200"
        },
        {
          field: "additional_info",
          label: "Additional Information",
          class: "enable-select-text",
          type: "input",
          searchable: true,
          visible: true,
          filterKey: { additional_info: "" },
          width: "200"
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      query: "",
      categoryId: null,
      lastSortColumn: null,
      lastSortOrder: null,
      responseData: [],
      reportingCategoryService: new ReportingCategoryService(),
      customerDataService: new CustomerProfileDataService()
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "isUserExternal",
      "userGroups"
    ]),
    isExternalUser() {
      // Don't show reporting responsible and comments section if user is external
      if (
        this.userGroups.includes(UserGroup.EXTERNAL_USER) &&
        this.isUserExternal
      ) {
        return true;
      }
      return false;
    },
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    isEnabled() {
      if (this.disabled == true) {
        // this is View action
        return false;
      } else if (
        this.workflowStatus == "Send for Approval" &&
        (this.isUserAdmin() ||
          (this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
            (this.customerAccountManager == this.userId ||
              this.backupCustomerAccountManager == this.userId)))
      ) {
        return true;
      }
      return false;
    },
    updateNoDataMsg() {
      if (this.isExternalUser && this.status != "Approved") {
        return "No categories were approved, please contact your Customer Account Manager for more information";
      } else {
        return "No results were found";
      }
    },
    getWorkFlowStatusClass() {
      switch (this.workflowStatus) {
        case "Draft":
          return "is-link";
        case "Send for Approval":
          return "is-warning";
        case "Approved":
          return "is-success";
        case "Rejected":
          return "is-danger";
        default:
          return "is-info";
      }
    }
  },
  watch: {
    customerAccountManager() {
      //Watches value of CAM and triggers this function if value of CAM changes
      this.fetchReportingCategoriesData();
    }
  },
  mounted() {
    this.fetchUserData();
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    forkJoin(this.fetchCustomerList()).subscribe(() => {
      this.fetchReportingCategoriesData();
    });
    const listElm = document.querySelector(
      ".reporting-category-table .table-wrapper"
    );
    listElm.addEventListener("scroll", e => {
      this.$refs.circul8Table.$refs.multiselect &&
        this.$refs.circul8Table.$refs.multiselect.forEach(element => {
          element.deactivate();
        });
      this.$refs.circul8Table.$refs.datePicker &&
        this.$refs.circul8Table.$refs.datePicker.forEach(element => {
          element.closePopup();
        });
    });
  },
  updated() {
    const listElm = document.querySelector(".table-wrapper");
    listElm.addEventListener("scroll", e => {
      const el = e.target;
      this.$refs.circul8Table.$refs.multiselect &&
        this.$refs.circul8Table.$refs.multiselect.forEach(element => {
          element.deactivate();
        });
      this.$refs.circul8Table.$refs.datePicker &&
        this.$refs.circul8Table.$refs.datePicker.forEach(element => {
          element.closePopup();
        });
    });

    // Update main_category column additionalInfo based on data
    const mainCategoryColumn = this.columns.find(
      col => col.field === "main_category"
    );
    if (mainCategoryColumn) {
      const hasDeletedCategories = this.data.some(row => row.isDeleted);
      mainCategoryColumn.additionalInfo = hasDeletedCategories;
    }
  },
  methods: {
    searchByFilter(filterQuery) {
      this.data = [];
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchReportingCategoriesData(query);
    },
    sortData(field, order) {
      this.data = [];
      // sort should always fetch page 1, so removing page param if exist
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&order_field" + "=" + field;
      const newOrderValue = "&order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchReportingCategoriesData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query && this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    fetchReportingCategoryHistory() {
      this.reportingCategoryService
        .fetchReportingCategoryHistory(this.$route.params.id)
        .subscribe(response => {
          this.prepareHistoryData(response);
        }, this.handleApiError);
    },
    isUserAdmin() {
      if (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)) {
        return true;
      }
      return false;
    },
    showHistoryModal() {
      this.isHistoryModalActive = true;
    },
    checkCheckBox(d) {
      this.checkedRow = d;
    },

    getClearFormObject() {
      return {
        id: null,
        customer: Number(this.$route.params.id),
        country: null,
        scheme: null,
        stream: null,
        reporting_category: null,
        reporting_sub_category: null,
        fee_per_kg: null,
        fee_per_unit: null,
        valid_from: null,
        valid_to: null,
        entity: null
      };
    },
    addModal() {
      this.isAdd = true;
      this.isEdit = false;
      this.action = "Add";
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.isAdd = true;
      this.isEdit = true;
      this.action = "Update";
      const editData = this.data.filter(i => i.id == editObject.id);
      this.editObject = editData.length ? editData[0] : [];
      this.editData = JSON.parse(JSON.stringify(this.editObject));
      //this.fetchCustomerSpecificPriceSingleData(editObject);
      this.isModalActive = true;
    },
    viewModal(editObject) {
      this.isAdd = false;
      this.isEdit = false;
      this.action = "View";
      const editData = this.data.filter(i => i.id == editObject.id);
      this.editObject = editData.length ? editData[0] : [];
      this.editData = JSON.parse(JSON.stringify(this.editObject));
      //this.fetchCustomerSpecificPriceSingleData(editObject);
      this.isModalActive = true;
    },
    deleteModal(editObject) {
      //this.isAdd = false;
      //this.action = "Delete";
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to delete?",
        cancelText: "No",
        confirmText: "Yes",
        onConfirm: () => this.deleteReprotingCategorySingleData(editObject)
      });
      //this.isModalActive = true;
    },
    editConfirm() {
      this.fetchReportingCategoriesData();
      this.isModalActive = false;
      this.checkedRow = [];
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    exportReportingCategory() {
      try {
        const set = new Set(
          this.checkedRow.map(cc => cc.id).map(result => JSON.stringify(result))
        );
        this.reportingCategoryService.export(
          Array.from(set).map(elem => JSON.parse(elem)),
          Number(this.$route.params.id)
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Upload Error !!!",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    exportReportingTemplate() {
      try {
        this.reportingCategoryService.exportReportingTemplateMethod(
          Number(this.$route.params.id)
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Upload Error !!!",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    changeWorkflowStatus(status) {
      this.reportingCategoryService
        .changeWorkflowStatus(
          this.$route.params.id,
          status,
          this.rejectComment,
          this.categoryId
        )
        .subscribe(() => {
          this.fetchReportingCategoriesData();
          this.isDataLoading = false;
          this.$buefy.toast.open({
            message: "Reporting Category Workflow Status Updated!",
            type: "is-success"
          });
          this.isCardModalActive = false;
        }, this.handleApiError);
    },
    fetchCustomerList() {
      const customerObservable = this.customerDataService.getCustomerList(
        this.$route.params.id
      );
      customerObservable.subscribe(
        customerProfiles => {
          this.customers = customerProfiles;
          this.customerMap = this.prepareMasterData(this.customers);
        },
        e => {
          console.log(e);
        }
      );
      return customerObservable;
    },
    prepareHistoryData(reportingCategory) {
      const columnData = [];

      if (reportingCategory.length > 0) {
        for (const report in reportingCategory) {
          columnData[report] = reportingCategory[report];
          columnData[report]["customer"] = this.customerMap[
            columnData[report]["customer"]
          ];
          columnData[report]["entity"] = this.customerMap[
            columnData[report]["entity"]
          ];
          columnData[report]["updated_by"] = this.userMap[
            columnData[report]["updated_by"]
          ];
          columnData[report]["updated_at"] = dayjs(
            columnData[report]["updated_at"]
          ).format("YYYY-MM-DD, HH:mm");
          for (const item in columnData[report]["reporting_category"]) {
            columnData[report][item] =
              reportingCategory[report]["reporting_category"][item];
          }
          columnData[report]["country"] = this.countryMap[
            columnData[report]["country"]
          ];
          columnData[report]["stream"] = this.containerMap[
            columnData[report]["stream"]
          ];
          columnData[report]["scheme"] = this.schemeMap[
            columnData[report]["scheme"]
          ];
        }

        this.historyData = columnData;
      }
    },
    prepareData(data) {
      const columnData = [];
      if (data.length > 0) {
        const reportingCategory = data[0]["reporting_category"];
        this.workflowStatus = data[0]["status"];
        this.updateDate = dayjs(data[0]["updated_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        this.approvedOrRejectedBy = this.userMap[
          data[0]["approved_or_rejected_by"]
        ];
        this.rejectionComment = data[0]["comment_for_rejection"];
        this.categoryId = data[0]["id"];
        for (const report in reportingCategory) {
          columnData[report] = reportingCategory[report];
          columnData[report]["customer"] = this.customerMap[
            data[0]["customer"]
          ];
          columnData[report]["customer_id"] = data[0]["customer"];
          columnData[report]["entity_id"] = reportingCategory[report]["entity"];
          columnData[report]["entity"] = this.customerMap[
            reportingCategory[report]["entity"]
          ];
          this.reportingCategoryId = columnData[report]["id"];
          for (const item in reportingCategory[report]["reporting_category"]) {
            columnData[report][item] =
              reportingCategory[report]["reporting_category"][item];
          }
          // Only set additional_info if is_deleted is true and main_category exists
          if (
            reportingCategory[report]["is_deleted"] &&
            columnData[report]["main_category"]
          ) {
            columnData[report]["additional_delete_info"] =
              "Category was removed from KDB";
          } else {
            columnData[report]["additional_delete_info"] = "";
          }
          columnData[report]["country_id"] = columnData[report]["country"];
          columnData[report]["stream_id"] = columnData[report]["stream"];
          columnData[report]["scheme_id"] = columnData[report]["scheme"];
          columnData[report]["country"] = this.countryMap[
            columnData[report]["country"]
          ];
          columnData[report]["stream"] = this.containerMap[
            columnData[report]["stream"]
          ];
          columnData[report]["scheme"] = this.schemeMap[
            columnData[report]["scheme"]
          ];
          columnData[report]["isDeleted"] =
            reportingCategory[report]["is_deleted"];
          columnData[report]["id"] = this.reportingCategoryId;
          columnData[report]["actions"] =
            this.isEditAllowed() && !reportingCategory[report]["is_deleted"];
          columnData[report]["delete"] = this.isEditAllowed();
        }
        if (this.isEditAllowed()) {
          this.data = columnData;
        } else {
          if (this.workflowStatus == "Approved") {
            this.data = columnData;
          } else {
            this.data = [];
          }
        }
      }
      if (this.data.length >= 10) {
        this.tableHeight = "height:560px";
      }
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    handleApiError(reason) {
      const errorMessage = reason.response.data["detail"];

      if (errorMessage != null && errorMessage != undefined) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: errorMessage,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        this.fetchReportingCategoriesData(this.query);
      }
    },
    deleteReprotingCategorySingleData(editObjectName) {
      this.reportingCategoryService.delete(editObjectName.id).subscribe(() => {
        this.$buefy.dialog.alert({
          title: "Success",
          message: "Reporting Category is Removed!"
        });
        this.fetchReportingCategoriesData();
      }, this.handleApiError);
    },
    isEditAllowed() {
      if (this.$route.fullPath.includes("/view/")) {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
      if (
        this.isUserAdmin() ||
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        (this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
          (this.customerAccountManager == this.userId ||
            this.backupCustomerAccountManager == this.userId))
      ) {
        this.showDelete = true;
        this.showEdit = true;
        return true;
      } else {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
    },
    fetchReportingCategoriesData(query = "") {
      this.isLoading = true;
      this.reportingCategoryService
        .getAll(this.$route.params.id, query)
        .subscribe(response => {
          this.responseData = JSON.parse(JSON.stringify(response));
          this.isLoading = false;
          this.prepareData(response);
          this.fetchReportingCategoryHistory();
        }, this.handleApiError);
    }
  }
};
</script>
<style scoped>
.actions-mobile {
  display: none;
}
.actions-desktop {
  display: block;
}
.action-dropdown {
  cursor: pointer;
}
@media (max-width: 1280px), (max-width: 60vw) {
  .actions-mobile {
    display: block;
  }
  .actions-desktop {
    display: none;
  }
}
</style>
